package com.evoapps.evoshift.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Device(
    val token: String,
    val platform: DevicePlatform,
    val lastActiveAt: String,
    val deviceName: String,
    /**
     * The app's language on this device ("pl", "en": appLanguage(), so the per-app language
     * setting), so the server writes its pushes in it (functions/pushText.js, SH-109). null from
     * apps before SH-109.
     */
    val language: String? = null
)

@Serializable
enum class DevicePlatform {
    ANDROID, IOS, WEB,

    /** The macOS desktop app (SH-97); it has no push token yet, so no device is registered. */
    DESKTOP
}
